import { catchError } from "./Error.action";
import { get, post } from "../Services/http";
import { FAVORITES_RECEIVE } from "../constants";

const rootRoute = '/api/favorite'

export const add = (articleNumber) => async (dispatch) => {
    try {
        const response = await post(`${rootRoute}/add?articleNo=${encodeURIComponent(articleNumber)}`, null);
        const result = await response.json();
        dispatch(receive(result));
    } catch (ex) {
        dispatch(catchError(ex, (error) => { console.error(error) }));
    }
};

export const remove = (articleNumber) => async (dispatch) => {
    try {
        const response = await post(`${rootRoute}/remove?articleNo=${encodeURIComponent(articleNumber)}`, null);
        const result = await response.json();
        dispatch(receive(result));
    } catch (ex) {
        dispatch(catchError(ex, (error) => { console.error(error) }));
    }
};

export const receive = (data) => ({
    type: FAVORITES_RECEIVE,
    payload: data,
});